import request from '@/config'
import { ModuleSearchDto, ModuleBaseDto, ModuleDeleteDto } from './dto';

enum Apis {
    ModuleTree = `/api/sysmodule/getsysmoduletree`,
    ModuleChild = `/api/sysmodule/getsysmodulechild`,
    Create = `/api/SysModule/InsertSysModule`,
    Modify = `/api/SysModule/UpdateSysModule`,
    Detail = `/api/SysModule/GetSysModuleInfo`,
    Delete = `/api/SysModule/DeleteSysModule`,
    ChecksTrees = `/api/sysmodule/getmoduletrees`,
    GetMenuTree = `/api/sysmodule/getmenutrees`
}

export const GetMenuTreeApi = (): Promise<IResponse> =>
    request.post({
        url: Apis.GetMenuTree,
        data: {}
    })

export const GetModuleTreesApi = (deletes: ModuleSearchDto): Promise<IResponse> =>
    request.post({
        url: Apis.ModuleTree,
        data: deletes
    })

const GetModuleChildApi = (rootId: string): Promise<IResponse> => {
    return request.post({ url: Apis.ModuleChild, data: { id: rootId } })
}


/* 系统模块：创建(CREATE) */
const ModuleCreateApi = (createIpt: ModuleBaseDto): Promise<IResponse> => {
    return request.post({ url: Apis.Create, data: createIpt })
}

/* 系统模块：修改(Modify) */
const ModuleEditApi = (modifyIpt: ModuleBaseDto): Promise<IResponse> => {
    return request.post({ url: Apis.Modify, data: modifyIpt })
}

/* 系统模块：获取详细(Detail) */
const ModuleDetailApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: Apis.Detail, data: { id: rowId } })

}

/* 系统模块：获取详细(Detail) */
const ModuleDeleteApi = (deleteInput: ModuleDeleteDto): Promise<IResponse> => {
    return request.post({ url: Apis.Delete, data: deleteInput })
}

/* 系统模块：获取详细(Detail) */
const GetModuleChecksApi = (): Promise<IResponse> => {
    return request.post({ url: Apis.ChecksTrees, data: {} })
}


export {
    GetModuleChildApi,
    ModuleCreateApi,
    ModuleEditApi,
    ModuleDetailApi,
    ModuleDeleteApi,
    GetModuleChecksApi
}

